import { GradientButton } from './gradient-button'

export const RedGradientButton: React.FC<IGradientButton> = (props) => (
  <GradientButton gradient="red" {...props} />
)
